import React, { FC } from 'react';
import { HeadFC, PageProps, graphql } from 'gatsby';

import View from '../views/404';
import LayoutRaw from '../components/Layout';
import SEO from '../components/Head';

interface ContextType {
  locale: string;
  name: string;
}

const Page: FC<PageProps<Queries.ErrorPageQueryQuery, ContextType>> = props => {
  const {
    data,
    pageContext: { locale },
  } = props;

  return (
    <LayoutRaw>
      <View file={data?.file} locale={locale} />
    </LayoutRaw>
  );
};
export const Head: HeadFC<Queries.ErrorPageQueryQuery, ContextType> = ({
  data: { file },
  pageContext,
  location,
}) => {
  return (
    <SEO
      meta={file?.childJson?.meta || null}
      pathname={location.pathname}
      locale={pageContext.locale}
    />
  );
};

export const query = graphql`
  query ErrorPageQuery($name: String!) {
    file(name: { eq: $name }, relativePath: { glob: "**/404/**" }) {
      childJson {
        ...Meta
        ...SeoNavbar
        ...ErrorContent
        ...SeoFooter
      }
    }
  }
`;

export default Page;
